import { useRef } from 'react'
import { Dialog, DialogContent, DialogActions, Button, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useModalFocusManager } from '@/hooks/useModalFocusManager'

// 모달 타입: alert(확인 1개), confirm(취소/확인)
export default function AlertConfirmModal({
  open,
  onClose,
  title,
  description,
  type = 'alert',    // 'alert' | 'confirm'
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
  onCancel,
  hideCancel = false,
  width = '480px',
}) {
  useModalFocusManager(open)
  const dialogRef = useRef(null)
  return (
    <Dialog
      ref={dialogRef}
      open={open}
      keepMounted
      disableEnforceFocus
      disableAutoFocus
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return
        onClose?.(event, reason)
      }}
      PaperProps={{
        sx: (theme) => ({
          maxWidth: width,
          width: '100%',
          borderRadius: 4,
          p: 3,
          maxHeight: '85dvh',
          minHeight: '226px'
        }),
      }}
      sx={{
        zIndex: (theme) => theme.zIndex.tooltip + 1,
      }}
    >
      {/* 닫기 버튼 */}
      <IconButton
        onClick={() => {
          onClose?.()
          onCancel?.()
        }}
        sx={{ position: 'absolute', top: 12, right: 12 }}
      >
        <CloseIcon />
      </IconButton>

      {/* 본문 설명 */}
      <DialogContent sx={{ p: 0 }}>
        {/* 타이틀 */}
        {title && (
          <Typography
            component="h6"
            variant="subtitle3"
            fontWeight={600}
            sx={{ mt: 3, mb: 2 }}
          >
            {title}
          </Typography>
        )}
        <Typography
          sx={{ whiteSpace: 'pre-line', }}
        >
          {description}
        </Typography>
      </DialogContent>

      {/* 버튼 영역 */}
      <DialogActions sx={{ justifyContent: 'flex-end', mt: 3 }}>
        {type === 'alert' && (
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        )}

        {type === 'confirm' && (
          <>
          {!hideCancel && (
            <Button
              variant="outlined"
              color="grey"
              size="medium"
              onClick={onCancel}
            >
              {cancelText}
            </Button>
          )}

            <Button
              variant="contained"
              color="primary"
              size="medium"
              onClick={onConfirm}
            >
              {confirmText}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  )
}
